import {
  fetchPlayerVersionsAction,
  unloadPlayerVersionsAction,
} from "fleet/redux-store/ui-state/player-versions/actions";
import { fetchOptionFactory } from "ui/fetch-options/fetch-option-factory";

const ConnectedPlayerVersionOptions = fetchOptionFactory(
  fetchPlayerVersionsAction,
  unloadPlayerVersionsAction,
);

export { ConnectedPlayerVersionOptions };
